import {
  CREATE_TESTRIDE_APPOINTMENT_FAIL,
  CREATE_TESTRIDE_APPOINTMENT_REQUEST,
  CREATE_TESTRIDE_APPOINTMENT_SUCCESS,
} from "../Constants/testrideConstants";

import axios from "axios";
import { useNavigate } from "react-router-dom";

export const createTestRide =
  (name, phoneNumber, city, country, zip, utmCampaign, gclid, pageVisited) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_REQUEST,
      });
      const { data } = await axios.post(
        "/api/testride/book",
        {
          name,
          phoneNumber,
          city,
          country,
          zip,
          utmCampaign,
          gclid,
          pageVisited,
        },
        config
      );

      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log(error.message);
      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const createPMAXTestRide =
  (
    name,
    phoneNumber,
    city,
    country,
    zip,
    utmCampaign,
    gclid,
    planToBuy,
    budget,
    pageVisited
  ) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_REQUEST,
      });
      const { data } = await axios.post(
        "/api/testride/book",
        {
          name,
          phoneNumber,
          city,
          country,
          zip,
          utmCampaign,
          gclid,
          planToBuy,
          budget,
          pageVisited,
        },
        config
      );

      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log(error.message);
      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const createPuneTestRide =
  (
    name,
    phoneNumber,
    city,
    country,
    zip,
    addressLine,
    addressType,
    utmCampaign,
    gclid,
    slotSelected,
    bikeSelected,
    dateSelected,
    pageVisited
  ) =>
  async (dispatch) => {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_REQUEST,
      });
      const { data } = await axios.post(
        "/api/testride/book",
        {
          name,
          phoneNumber,
          city,
          country,
          zip,
          addressLine,
          addressType,
          utmCampaign,
          gclid,
          slotSelected,
          bikeSelected,
          dateSelected,
          pageVisited,
        },
        config
      );

      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_SUCCESS,
        payload: data,
      });
      return data;
    } catch (error) {
      console.log(error.message);
      dispatch({
        type: CREATE_TESTRIDE_APPOINTMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };
